import { render, staticRenderFns } from "./MSOChartOfAccountEditor.vue?vue&type=template&id=452ac420&"
import script from "./MSOChartOfAccountEditor.vue?vue&type=script&lang=js&"
export * from "./MSOChartOfAccountEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports